export default {
  root: {
    borderRadius: '4px',
  },
};
